import { ca } from '@cian/analytics';

import { IJsonQuery } from '../../../packages/api-models/common/json_query';
import { TFilterType } from '../../common/types/filterType';

interface ITrackFilterFromChipsApplyArgs {
  queryString: string;
  pageType: 'Listing' | 'Map';
  filterType?: TFilterType;
  jsonQuery: IJsonQuery;
}

export const trackFilterFromChipsApply = ({
  queryString,
  pageType,
  jsonQuery,
  filterType,
}: ITrackFilterFromChipsApplyArgs) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'FastFilters',
    action: 'popup_confirm',
    label: queryString,
    page: { pageType, extra: { filter_type: filterType } },
    sc: jsonQuery,
  });
};
